<template>
  <el-radio-group v-if="data.setting.isRemote && model" v-model="model[data.fieldId]">
    <el-radio v-for="r in remoteData" :key="r[data.setting.remoteDataProps.value]" :label="r[data.setting.remoteDataProps.value]">{{ r[data.setting.remoteDataProps.label] }}</el-radio>
  </el-radio-group>
  <el-radio-group v-else-if="data.setting.isRemote && !model" v-model="data.defaultValue">
    <el-radio v-for="r in remoteData" :key="r[data.setting.remoteDataProps.value]" :label="r[data.setting.remoteDataProps.value]">{{ r[data.setting.remoteDataProps.label] }}</el-radio>
  </el-radio-group>
  <el-radio-group v-else-if="!data.setting.isRemote && model" v-model="model[data.fieldId]">
    <el-radio v-for="r in data.selections" :key="r.value" :label="r.value">{{ r.label }}</el-radio>
  </el-radio-group>
  <el-radio-group v-else v-model="data.defaultValue">
    <el-radio v-for="r in data.selections" :key="r.value" :label="r.value">{{ r.label }}</el-radio>
  </el-radio-group>
</template>

<script>
import RemoteMixin from '../../mixins/remote'
export default {
  name: 'HRadio',
  mixins: [RemoteMixin],
  props: {
    data: {
      type: Object,
      required: true
    },
    model: {
      type: [Object, null],
      default: null
    }
  }
}
</script>
